module.exports = __webpack_public_path__ + "static/media/jardines05M.4057092d.jpg";